module.exports = __webpack_public_path__ + "img/521.29f3420f.png";